export default "__VITE_ASSET__5bOv3Sg___"